import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function clone<T>() {
  // todo: implement using a property clone function (eg from lodash)
  return (source$: Observable<T>) => source$.pipe(map(x => (Array.isArray(x) ? [...x] : { ...x }) as T));
}
